import { Map as ImmutableMap } from 'immutable';
import { MemorizedRuleProps } from 'companion-app-components/flux/memorized-rules/memorizedRulesTypes';
import { MemorizedRuleType } from './types';

export const isComplexRule = (memorizePayeeRule: MemorizedRuleProps): boolean =>
  Boolean(memorizePayeeRule?.amountCondition || memorizePayeeRule?.accountIds?.length);

export const getMemorizedRuleWithSamePayeeName = (
  rules: ImmutableMap<string, MemorizedRuleProps>, payeeName: string,
): ImmutableMap<string, MemorizedRuleProps> => {

  const trimmedName = (payeeName ?? '').trim();
  if (!trimmedName) {
    return ImmutableMap(); // return empty map if payeeName is empty
  }

  return rules.filter(
    (rule) => (rule.payee ?? '').trim() === trimmedName,
  ) as ImmutableMap<string, MemorizedRuleProps>;
};

export const getMemorizedRuleType = (memorizePayeeRule: MemorizedRuleProps) => {
  let ruleType: MemorizedRuleType = MemorizedRuleType.NORMAL;
  if (memorizePayeeRule?.amountCondition && memorizePayeeRule?.accountIds?.length) {
    ruleType = MemorizedRuleType.ACCOUNT_AND_AMOUNT_TYPE;
  } else if (memorizePayeeRule?.amountCondition) {
    ruleType = MemorizedRuleType.AMOUNT_TYPE;
  } else if (memorizePayeeRule?.accountIds?.length) {
    ruleType = MemorizedRuleType.ACCOUNT_TYPE;
  }
  return ruleType;
};

export const sortMemorizePayeeList = (
  ord: 'asc' | 'desc',
  attr: string,
  mp: ImmutableMap<string, MemorizedRuleProps>,
) => {
  const sorted = mp.sort((a, b) => {
    const valA = a[attr];
    const valB = b[attr];

    if (valA == null && valB == null) return 0;
    if (valA == null) return ord === 'asc' ? 1 : -1;
    if (valB == null) return ord === 'asc' ? -1 : 1;

    // If the column is 'amount', use numeric comparison
    if (attr === 'amount') {
      const numA = Number(valA);
      const numB = Number(valB);
      return ord === 'asc' ? numA - numB : numB - numA;
    }

    // Fallback to localeCompare for strings
    const strA = String(valA);
    const strB = String(valB);
    const cmp = strA.localeCompare(strB, undefined, {
      numeric: true,
      sensitivity: 'base',
    });

    return ord === 'asc' ? cmp : -cmp;
  });

  return sorted;
};
